export class ProfileSettingKeys {
  static readonly filterFavourites = "filter/favorites/";
  static readonly userProfileDefaultBlotter = "userprofile/default/blotter/";
  static readonly userProfileFindBlotter = "userprofile/default/find/";
  static readonly userProfileGLPopoutContainer = "userprofile/goldenlayout/popoutcontainer/";
  static readonly userProfileGLContent = "userprofile/goldenlayout/content";
  static readonly userProfileFavoritesAutocomplete = "userprofile/favorites/autocomplete";
  //user settings
  static readonly userProfileSettingsLadderOrdersPreferences =
    "userprofile/settings/ladderorders/preferences";
  static readonly userProfileSettingsTradeBlotterPreferences =
    "userprofile/settings/tradeblotter/preferences";
  static readonly userProfileSettingsRiskTradeBlotterPreferences =
    "userprofile/settings/risktradeblotter/preferences";
  static readonly userProfileSettingsBmarkSummaryPreferences =
    "userprofile/settings/bmarksummary/preferences";
  static readonly userProfileSettingsAllocationBlotterPreferences =
    "userprofile/settings/allocationblotter/preferences";
  static readonly userProfileSettingsOrderBlotterTemperatures =
    "userprofile/settings/orderblotter/temperatures";
  static readonly userProfileSettingsOrderBlotterPreferences =
    "userprofile/settings/orderblotter/preferences";
  static readonly userProfileSettingsNotifPopup = "userprofile/settings/notifications/popup";
  static readonly userProfileSettingsNotifApp = "userprofile/settings/notifications/application";
  static readonly userProfileSettingsNotifBmarkPopup =
    "userprofile/settings/notifications/bmark/popup";
  static readonly userProfileSettingsNotifBmarkApp =
    "userprofile/settings/notifications/bmark/application";
  static readonly userProfileFwdRoll = "userprofile/fwdroll";
  static readonly userProfileFwdRollBlotters = "userprofile/fwdroll/blotter/";

  static readonly userProfileAlgoMonitor = "userprofile/algomonitor";

  static readonly userThemeSettings = "userprofile/settings/general/themesetting";
  static readonly userLanguageSettings = "userprofile/settings/general/languagesetting";
  static readonly userZoomSetting = "userprofile/settings/general/zoom";
  static readonly userSaveProfileOnLogout = "userprofile/settings/general/saveProfileOnLogout";
  static readonly defPortfolioSetting = "userprofile/settings/general/defPortfolio";
  // user settings order entry defaults
  static readonly userOrderEntrySpotSettings = "userprofile/settings/orderentry/spot";
  static readonly userOrderEntryNdfSettings = "userprofile/settings/orderentry/ndf";
  static readonly userOrderEntryAlgoSettings = "userprofile/settings/orderentry/algo";
  static readonly userOrderEntryNDFAlgoSettings = "userprofile/settings/orderentry/ndfalgo";
  static readonly userOrderEntryBmarkSettings = "userprofile/settings/orderentry/bmark";
  static readonly userOrderEntryGammaSettings = "userprofile/settings/orderentry/gamma";
  static readonly userOrderEntryPreferencesSettings = "userprofile/settings/orderentry/preferences";
  static readonly userOrderEntryActiveTabsSettings = "userprofile/settings/orderentry/tabs";
  //user preferences ONLY USED FOR WORKER / MAIN THREAD
  static readonly userPreferences = "userprofile/settings/orderblotter/user_preferences";
  // user preferences benchmark summary
  static readonly userBmarkSummaryPreferences = "userprofile/settings/bmarksummary/active_tab";
  static readonly userBMContainerPreferences = "userprofile/settings/bmarksummary";
  static readonly userBmarkSummaryFixingPanelSizes =
    "userprofile/settings/bmarksummary/fixingPanelSizes";
}
